import * as yup from 'yup';
import type { StringSchema } from 'yup';

declare module 'yup' {
    interface StringSchema {
        noSpaces(): StringSchema;
        onlyAlphanumericUnderscore(): StringSchema;
        noCyrillic(): StringSchema;
    }
}

const noSpaceValidator = (value: string | undefined) => {
    if (value) {
        return !value.includes(' ');
    }
    return false;
};

const alphanumericUnderscoreValidator = (value: string | undefined) => {
    return value === undefined || value === '' || /^\w*$/.test(value); // allow only letters, digits, underscore
};

function methodAlphanumericUnderscoreValidate(this: StringSchema) {
    return this.test('alphanumeric-underscore', 'Key can only contain letters, digits, and underscores', alphanumericUnderscoreValidator);
}

function methodSpacesValidate(this: StringSchema) {
    return this.test('no-spaces', 'Space are not allowed in this field', noSpaceValidator);
}

yup.addMethod<StringSchema>(yup.string, 'noCyrillic', function (message?: string) {
    return this.test(
        'no-cyrillic',
        message ?? 'Cyrillic characters are not allowed',
        (value?: string) => !value || !/[\u0400-\u04FF]/.test(value)
    );
});

export { methodSpacesValidate, methodAlphanumericUnderscoreValidate };
